import CheckIcon from '@mui/icons-material/Check';
import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import { useTheme } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';
import Tooltip from '@zenbusiness/zui/Tooltip';

import * as Styled from './BuyBox.style';

const messageFormatValues = {
  b: (chunks) => <Box component="b">{chunks}</Box>
};

function Features({ features = [] }) {
  const { palette } = useTheme();

  return (
    <Stack gap={1}>
      {features.map((feature) => (
        <Styled.FeatureItem key={feature.title}>
          <CheckIcon color="success" sx={{ width: '1.125rem', height: '1.125rem' }} />
          <Text size="sm" color="secondary">
            <FormattedMessage id={feature.title} values={messageFormatValues} />
          </Text>
          {!!feature.description && (
          <Tooltip
            arrow={false}
            componentsProps={{
              tooltip: {
                sx: {
                  width: '13rem',
                  borderRadius: '0.25rem',
                  padding: '0.5rem'
                }
              }
            }}
            enterTouchDelay={0}
            leaveTouchDelay={15000}
            title={(<Text size="xs" weight="regular"><FormattedMessage id={feature.description} /></Text>)}
            placement="top-start"
          >
            <SharedAsset
              alt=""
              color={palette.info.light}
              src="/icon/micro/info-circle-alt.svg"
              width={20}
            />
          </Tooltip>
          )}
        </Styled.FeatureItem>
      ))}
    </Stack>
  );
}

Features.propTypes = {
  features: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string
    })
  )
};

export default Features;
